import { useEffect, useState } from 'react'
import { useAppSelector } from '../../redux/app/hooks';
import { useChimeMeeting } from '../../Chime/ChimeMeetingContext';
import { getChimeParticipants } from '../../Chime/helpers/get-participants';
import { GET_SESSTION_BY_ID, UPDATE_SESSION_STATUS } from '../../pages/LiveClass/api/LiveClassQuery';
import { useLazyQuery, useMutation } from '@apollo/client';
import { FETCH_POLICY_NO_CACHE, JITSI, PATH_ADDRESSES, PTA_ROLE, SCHOOL_ADMIN, STUDENT_ROLE, SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR, SUBJECT_NOT_FOUND_ERROR, TEACHER_ROLE } from '../../utils/constants';
import { singleSessionType } from '../../pages/LiveClass/LiveClass';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import ToasterWithMessage from '../toaster';
import { UPDATE_LIVECLASS_HOST_ID, UPDATE_LIVECLASS_MEET_CHAT_STATUS, UPDATE_LIVECLASS_REPLICA_MEETING_IDS } from '../../Chime/helpers/Api/ChimeApi';
import { setCurrentPtaMeetId, setCurrentPtaMeetMCode, setCurrentSessionDetail, setCurrentSessionId, setCurrentSessionRecordingDetail, setCurrentSessionTopic, setCurrentUserId, setCurrentWorkshopId, setIsStartingMeeting, setMeetComponentName } from '../../redux/slices/dashboardSlice';
import { useDispatch } from 'react-redux';
import { captureEvent, updateUserProperties } from '../../utils/PostHogHelper';
import WarningPopup from '../WarningPopup/WarningPopup';
import { createChimeMeeting } from '../../Chime/helpers/create-meeting';
import { useMeetingManager } from 'amazon-chime-sdk-component-library-react';
import Loader from '../Loader/Loader';
import { closeWindow } from '../../utils/chimeHelper';
import { GET_WORKSHOP_BY_ID, UPDATE_WORKSHOP_MEETING_ID } from '../../pages/Workshop/api/WorkshopQuery';
import { clickedWorkshopDetails } from '../../pages/Workshop/Workshop';
import { trackMettingEvent } from '../../firebase/analyticsHelper';
import { GET_PTA_MEETING_BY_ID, UPDATE_MEETING_STATUS } from '../../pages/AdminPta/api/PtaQuery';
import { PtaMeetType } from '../../pages/PtaMeetings/PtaMeetings';

const PreChimeMeeting = () => {
    const [searchParams] = useSearchParams();
    const meetComponent = useAppSelector((state) => state?.dashboard?.meetComponent);
    const profile = useAppSelector((state) => state?.auth?.adminProfile);
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const meetService = useAppSelector((state) => state.auth.meetService);
    const role = useAppSelector((state) => state.auth.role);
    const currentUserId = useAppSelector((state) => state?.dashboard?.currentUserId);
    const [singleSessionDetail,setSingleSessionDetail] = useState<singleSessionType>(); 
    const [singleWorkshopDetail,setSingleWorkshopDetail] = useState<clickedWorkshopDetails>();
    const [singlePtaDetail,setSinglePtaDetail] = useState<PtaMeetType>(); 
    const navigate = useNavigate();
    const {state} = useLocation();
    const {error} = ToasterWithMessage();
    const dispatch = useDispatch();
    const loginpage = useAppSelector((state) => state.auth.loginpage);
    const [warningMessage, setWarningMessage] = useState<string>('');
    const [openWarningPopup, setOpenWarningPopup] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const REPLICA_THRESHOLD = parseInt(process.env.REACT_APP_REPLICA_THRESHOLD ?? "240");
    const meetingManager = useMeetingManager();
    const { createMeeting, joinMeeting, setIsRecording, setRecordingStartTime, showChat, setShowChat, setHostId, setHostAttendeeId, setMediaPipelineArn, setMediaPipelineId } = useChimeMeeting();

    const closeWarnPopup = () => {
        setOpenWarningPopup(false);
        setWarningMessage("");
    }

    
    const getPreviewStream = async () => {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true});
          console.log("[Log] stream", stream, stream?.getTracks());
          stream.getTracks().forEach((track) => track.stop());
          return stream;
        } catch (err: any) {
          console.log("[Log] getPreviewStream Error", err);
          let errorMessage = "Unable to access your camera or microphone. Please check your device settings and try again.";
          if (err?.name === "NotAllowedError" || err?.name === "SecurityError") {
            errorMessage = "Permission denied. Please allow camera and microphone access.";
          } else if (err?.name === "NotFoundError" || err?.name === "DevicesNotFoundError") {
            errorMessage = "No camera or microphone found. Please check your device.";
          } else if (err?.name === "NotReadableError" || err?.name === "HardwareAccessError") {
            errorMessage = "Another app is using your camera or microphone. Close the other app and try again.";
          } else if (err?.name === "OverconstrainedError") {
            errorMessage = "Your camera does not support the requested video resolution.";
          }
          setWarningMessage(errorMessage);
          setOpenWarningPopup(true);
          setLoading(false);
        }
    };

    const [updateSessionStatus] = useMutation(UPDATE_SESSION_STATUS, {
      fetchPolicy: FETCH_POLICY_NO_CACHE,
      onCompleted: (data) => {
      },
      onError: (err) => {
        setLoading(false);
        dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
        
      }
    });

    // Mutation to update liveclass host id and original host id
    const [updateHostIdForLiveclass] = useMutation(UPDATE_LIVECLASS_HOST_ID, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
          console.log("Liveclass host id updated successfully", data);
        },
        onError: (err) => {
            dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
            error(err?.message);
        }
    }); 
    
    // Mutation to update liveclass chat status
    const [updateChatStatusForLiveclass] = useMutation(UPDATE_LIVECLASS_MEET_CHAT_STATUS, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
          console.log("Liveclass host id updated successfully", data);
        },
        onError: (err) => {
            dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
            error(err?.message);
            setLoading(false);
        }
    });  
    
    // Mutation to update liveclass host id and original host id
    const [updateLiveClassReplicaIds] = useMutation(UPDATE_LIVECLASS_REPLICA_MEETING_IDS, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
          console.log("Liveclass host id updated successfully", data);
        },
        onError: (err) => {
            dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
            error(err?.message);
            setLoading(false);
        }
    });     

    const [getSingleSession] = useLazyQuery(GET_SESSTION_BY_ID, {
      fetchPolicy: FETCH_POLICY_NO_CACHE,
      onCompleted: async (data) => {
        const response = data?.getSession || {};
        const meetId = response?.sessionCode;
        if (meetId && meetService !== JITSI) {
          getChimeParticipants(meetId)
            .then((participantsResponse) => {
              response.participantscount = participantsResponse?.Attendees ? participantsResponse?.Attendees?.length : 0;
            })
            .catch(() => {
              response.participantscount = 0;
            })
            .finally(() => {
              console.log("[Log] Participants count:", response.participantscount, response);
                setSingleSessionDetail(response);
            });
        } else {
            setSingleSessionDetail(response);
        }
      },
      onError: (err) => {
        if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
          error(err?.message);
          setTimeout(() => {
            if(role === STUDENT_ROLE){
              navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
           }else{
              navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
           }
          }, 2000);
        } else if(err?.message === "Session has ended"){
        } else {
          error(err?.message)
        }
        dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
        setLoading(false);
        closeWindow(state);
      }
    });


    const [getSingleWorkshopSession] = useLazyQuery(GET_WORKSHOP_BY_ID, {
      fetchPolicy: FETCH_POLICY_NO_CACHE,
      onCompleted: (data) => {
          const response = data?.getWorkShopByWsId || {};
          const meetId = response?.wsCode;

          if (meetId && meetService !== JITSI) {
              getChimeParticipants(meetId)
                  .then((participantsResponse) => {
                      response.wsParticipantsCount = participantsResponse?.Attendees ? participantsResponse?.Attendees?.length : 0;
                  })
                  .catch(() => {
                      response.wsParticipantsCount = 0;
                  })
                  .finally(() => {
                          setSingleWorkshopDetail(response);
                  });
          } else {
                  setSingleWorkshopDetail(response);
          }
      },
      onError: (err) => {
      dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
        setLoading(false);
        closeWindow(state);
      }
    });   
    
    
  const [getSinglePtaMeeting] = useLazyQuery(GET_PTA_MEETING_BY_ID, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
        const response = data?.getMeetingById || {};
        const meetId = response?.mCode;

        console.log("meet id, meet service", meetId, meetService)
        if (meetId && meetService !== JITSI) {
          getChimeParticipants(meetId)
            .then((participantsResponse) => {
              response.mParticipantCount = participantsResponse?.Attendees ? participantsResponse.Attendees.length : 0;
            })
            .catch(() => {
              response.mParticipantCount = 0;
            })
            .finally(() => {
              console.log("[Log] Participants count:", response.mParticipantCount);
              setSinglePtaDetail(response);
            });
        } else {
          setSinglePtaDetail(response);
        }
    },
    onError: (err) => {  
      dispatch(setIsStartingMeeting({ isStartingMeeting: false }));    
      setLoading(false);
    }
  });    

  const [updateSessionId] = useMutation(UPDATE_WORKSHOP_MEETING_ID, {
      fetchPolicy: FETCH_POLICY_NO_CACHE,
      onError: (err) => {
        setLoading(false);
        dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
      }
  });    

  const [updateMeetStatus] = useMutation(UPDATE_MEETING_STATUS, {
      fetchPolicy: FETCH_POLICY_NO_CACHE,
      onError: (err) => {
        dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
        setLoading(false);
      }
    });
    
    const liveclassStartFunctionality = async (stream:any) => {
      console.log("Starting liveclass for userId:",profile, currentUserId);
      if(currentUserId) {
        await createMeeting(currentUserId).then(async (response) => {
            console.log('[Log] createMeeting response', response);
            const meetId = response?.Meeting?.MeetingId;
            if (meetId) {

            const participants = await getChimeParticipants(meetId);
            let hostAttendee:any = null;
            // Find the host attendee
            if(participants?.Attendees){
                hostAttendee =  participants.Attendees.find(
                    (attendee) => attendee.ExternalUserId === currentUserId
                );
            }

            localStorage.setItem("hostId", currentUserId ?? "");
            localStorage.setItem("hostAttendeeId", hostAttendee?.AttendeeId ?? "");
            setHostAttendeeId(hostAttendee?.AttendeeId || ''); 
            await updateSessionStatus({
                variables: {
                cId: selectedClassRoomId,
                sjId: selectedSubjectId,
                sId: singleSessionDetail?.sessionId,
                sCode: meetId,
                hostId: currentUserId,
                }
            });

            await updateHostIdForLiveclass({
                variables: {
                input: {
                    pCId: selectedClassRoomId,
                    pSubjectId: selectedSubjectId,
                    pSessionId: singleSessionDetail?.sessionId,
                    pHostId: currentUserId,
                    pUpdateOriginal: true
                    }
                }
            });

            const chatStatus = !(singleSessionDetail?.isSessionStart) ? (localStorage.getItem("showChatPreference") ? JSON.parse(localStorage.getItem("showChatPreference") || "false") : false) : singleSessionDetail?.showChat;
            await updateChatStatusForLiveclass({
                variables: {
                cId: selectedClassRoomId,
                sjId: selectedSubjectId,
                sessionId: singleSessionDetail?.sessionId,
                showChat: chatStatus
                }
            });

            if (singleSessionDetail?.sessionId) {
                if (singleSessionDetail?.isSessionStart) {
                    setShowChat(singleSessionDetail?.showChat);
                }
                dispatch(setCurrentSessionId({ currentSessionId: singleSessionDetail?.sessionId }));
                localStorage.setItem("SessionId",singleSessionDetail?.sessionId);
                dispatch(setCurrentSessionDetail({ startDate: singleSessionDetail?.startdate, endDate: singleSessionDetail?.enddate, mediaPipelineArn : singleSessionDetail?.mediaPipelineArn ?? null , mediaPipelineId : singleSessionDetail?.mediaPipelineId ?? null  }));
                dispatch(setCurrentSessionRecordingDetail({ recordingStartedTime: singleSessionDetail?.recordStartTime, recordingStarted: singleSessionDetail?.isRecordStart }));
                dispatch(setCurrentSessionTopic({ currentSessionTopic: singleSessionDetail?.lessonTopic }));
            }
            if(currentUserId) {
                    updateUserProperties({
                        meetingId: meetId,
                    });
                    captureEvent(currentUserId, {
                        role: role,
                        loginType: loginpage, // your redux login type
                        meetingId: meetId,
                    });
            }   
            const existingState = state; // coming from useLocation() or props
            const newState = {
                ...existingState,
                sessionId: singleSessionDetail?.sessionId
            }

            // Save to storage
            localStorage.setItem("meetingState", JSON.stringify(newState));
            localStorage.setItem("isJoined", "joined");    
            setLoading(false);
            navigate(`/teacher-classroom/liveclass/meeting?meetId=${meetId}`, { state: { ...state, sessionId: singleSessionDetail?.sessionId }});      
            }
        }).catch((error) => {
            console.log("Creating Meeting Error :", error);
            localStorage.setItem("isJoined", "left");
            dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
            setLoading(false);
            stream.getAudioTracks()[0].stop();
            stream.getVideoTracks()[0].stop();
        });
    }
    }


    const liveclassJoinFunctionality = async (stream:any) => {
      dispatch(setCurrentUserId({ currentUserId: currentUserId || '' }));
      dispatch(setMeetComponentName({ meetComponent: 'liveclass' }));
      if (singleSessionDetail?.sessionCode && singleSessionDetail?.hostId) {
        let primaryMeetingId = singleSessionDetail?.sessionCode;
        const replicaMeetingIds: string[] = singleSessionDetail?.replicaMeetingIds || [];

        // Combine the primary meeting and any replica meetings into one list
        const allMeetingIds = [primaryMeetingId, ...replicaMeetingIds];
        console.log("All Meeting Ids:", allMeetingIds);

        // Fetch participant counts for all meeting IDs in parallel
        const meetingCountsPromises = allMeetingIds.map(async (id) => {
            const response = await getChimeParticipants(id);
            const count = response?.Attendees ? response?.Attendees?.length : 0;
            return { id, count };
        });
        const meetingCounts = await Promise.all(meetingCountsPromises);
        console.log("Meeting Counts:", meetingCounts);

        // Decide which meeting instance to join: choose the first meeting that isn't full.
        let chosenMeetingId: string | null = null;
        for (const { id, count } of meetingCounts) {
            if (count < REPLICA_THRESHOLD) {
              chosenMeetingId = id;
              break;
            }
        }

        // If all existing meeting instances are full, create a new replica meeting.
        if (!chosenMeetingId) {
          const replicaMeetingResponse = await createChimeMeeting(
            singleSessionDetail?.sessionCode
          );
          const newReplicaMeetingId =
            replicaMeetingResponse?.Meeting?.MeetingId;
          if (newReplicaMeetingId) {
            // Update the replica meetings array by appending the new meeting ID.
            const updatedReplicaMeetingIds = [
              ...replicaMeetingIds,
              newReplicaMeetingId,
            ];
            await updateLiveClassReplicaIds({
              variables: {
                cId: selectedClassRoomId,
                sjId: selectedSubjectId,
                sessionId: singleSessionDetail?.sessionId,
                replicaMeetingIds: updatedReplicaMeetingIds
              }
            })
            chosenMeetingId = newReplicaMeetingId;
          }
        }

        // Fallback: if still no meeting is chosen, default to primary meeting
        const finalMeetingId = chosenMeetingId || primaryMeetingId;        
        const originalHostId =  singleSessionDetail.originalHostId
        let hostAttendee: any = null;
        let hostExternalUserId: any = "";

        // Assume you already have these
        await getChimeParticipants(finalMeetingId)
          .then((participants) => {
            console.log("[Log] Participants List:", participants);
            console.log(
              "userId",
              currentUserId,
              "singleSessionDetail.hostId",
              singleSessionDetail.hostId,
              "originalHostId",
              originalHostId
            );
            if (currentUserId === originalHostId) {
              hostExternalUserId = currentUserId;
            } else {
              hostExternalUserId = singleSessionDetail.hostId;
            }
            // Find the host attendee
            if (participants?.Attendees) {
              console.log("by using this hostExternalUserId", hostExternalUserId);
              hostAttendee = participants.Attendees.find((attendee: any) => {
                console.log("Checking attendee:", attendee.ExternalUserId);
                return attendee.ExternalUserId === hostExternalUserId;
              });
            }
          })
          .catch((error) => {
            console.error("Failed to fetch participants:", error);
          });

        if (hostAttendee) {
          console.log("Host AttendeeId:", hostAttendee.AttendeeId);
        } else {
          console.log("Host not found in the participants list");
        }        

        await joinMeeting(
          finalMeetingId,
          originalHostId === currentUserId
            ? currentUserId
            : singleSessionDetail.hostId === currentUserId
            ? singleSessionDetail.hostId
            : `${currentUserId}|${Date.now()}`,
          singleSessionDetail.hostId,
          originalHostId,
          hostAttendee?.AttendeeId || ''
        )
          .then(async (response) => {
            console.log("[Log] joinMeeting response", response);
            const meetId = response?.meetingResponse?.Meeting?.MeetingId;
            if (meetId) {
              if (currentUserId === originalHostId) {
                await getChimeParticipants(meetId)
                  .then((participantsResponse) => {
                    console.log(
                      "userId",
                      currentUserId,
                      "singleSessionDetail.hostId",
                      singleSessionDetail.hostId,
                      "originalHostId",
                      originalHostId
                    );
                    hostExternalUserId = currentUserId;
                    // Find the host attendee
                    if (participantsResponse?.Attendees) {
                      hostAttendee = participantsResponse.Attendees.find((attendee: any) => {
                        console.log("Checking attendee:", attendee.ExternalUserId);
                        return attendee.ExternalUserId === hostExternalUserId;
                      });
                      console.log(
                        "Host AttendeeId after joining:",
                        hostAttendee?.AttendeeId || ""
                      );
                      setHostAttendeeId(hostAttendee?.AttendeeId || "");
                      console.log(
                        singleSessionDetail.mediaPipelineArn,
                        singleSessionDetail.mediaPipelineId,
                        "mediapipeline",
                        originalHostId
                      );
                      localStorage.setItem("hostId", currentUserId ?? "");
                      localStorage.setItem("hostAttendeeId", hostAttendee?.AttendeeId ?? "");
                    }
                  })
                  .catch((error) => {
                    console.error("Failed to fetch participants:", error);
                  });

                console.log(currentUserId, originalHostId, "originalHost");
                setHostId(currentUserId);
                console.log(
                  singleSessionDetail.mediaPipelineArn,
                  singleSessionDetail.mediaPipelineId,
                  "mediapipeline",
                  originalHostId
                );

                setMediaPipelineArn(singleSessionDetail.mediaPipelineArn);
                setMediaPipelineId(singleSessionDetail.mediaPipelineId);
                meetingManager.audioVideo?.addObserver({
                  audioVideoDidStart: () => {
                    console.log("[Log] audioVideoDidStart - Sending realtime message");
                    try {
                      const message = {
                        action: "host-changed",
                        hostId: currentUserId,
                        hostAttendeeId: hostAttendee?.AttendeeId || "",
                        ...(singleSessionDetail.mediaPipelineId && {
                          mediaPipelineId: singleSessionDetail.mediaPipelineId,
                        }),
                        ...(singleSessionDetail.mediaPipelineArn && {
                          mediaPipelineArn: singleSessionDetail.mediaPipelineArn,
                        }),
                      };

                      meetingManager.meetingSession?.audioVideo?.realtimeSendDataMessage(
                        "live-update",
                        JSON.stringify(message)
                      );
                    } catch (error) {
                      console.error("Failed to send realtime message:", error);
                    }
                  },
                });
                await updateHostIdForLiveclass({
                  variables: {
                    input: {
                      pCId: selectedClassRoomId,
                      pSubjectId: selectedSubjectId,
                      pSessionId: singleSessionDetail?.sessionId,
                      pHostId: currentUserId,
                      pUpdateOriginal: false,
                    },
                  },
                });
              }              
              if (singleSessionDetail?.sessionId) {
                setShowChat(singleSessionDetail?.showChat);
                dispatch(
                  setCurrentSessionId({
                    currentSessionId: singleSessionDetail?.sessionId,
                  })
                );
                localStorage.setItem("SessionId",singleSessionDetail?.sessionId);
                dispatch(
                  setCurrentSessionDetail({
                    startDate: singleSessionDetail?.startdate,
                    endDate: singleSessionDetail?.enddate,
                    mediaPipelineArn : singleSessionDetail?.mediaPipelineArn ?? null, 
                    mediaPipelineId : singleSessionDetail?.mediaPipelineId ?? null
                  })
                );
                dispatch(
                  setCurrentSessionRecordingDetail({
                    recordingStartedTime: singleSessionDetail?.recordStartTime,
                    recordingStarted: singleSessionDetail?.isRecordStart,
                  })
                );
                setRecordingStartTime(singleSessionDetail?.recordStartTime);
                setIsRecording(singleSessionDetail?.isRecordStart);
                dispatch(
                  setCurrentSessionTopic({
                    currentSessionTopic: singleSessionDetail?.lessonTopic,
                  })
                );
                setShowChat(singleSessionDetail?.showChat);
              }
              if (currentUserId) {
                updateUserProperties({
                  meetingId: meetId, // overwrite old value
                });
                captureEvent(currentUserId, {
                  role: role,
                  loginType: loginpage, // your redux login type
                  meetingId: meetId,
                });
              }

              const existingState = state; // coming from useLocation() or props          
              if (role === STUDENT_ROLE) {
                  const newState = {
                    ...existingState,   
                    sessionId: singleSessionDetail?.sessionId
                    };

                    // Save to storage
                    localStorage.setItem("meetingState", JSON.stringify(newState));
                    localStorage.setItem("isJoined", "joined");

                    setLoading(false);
                    navigate(
                        `/student-classroom/liveclass/meeting?meetId=${meetId}`,
                        {
                            state: {
                            ...state,
                            sessionId: singleSessionDetail?.sessionId,
                            },
                        }
                    );
              } else if (role === TEACHER_ROLE) {
                  const newState = {
                    ...existingState,   
                    sessionId: singleSessionDetail?.sessionId
                    };

                    // Save to storage
                    localStorage.setItem("meetingState", JSON.stringify(newState));
                    localStorage.setItem("isJoined", "joined");

                    setLoading(false);
                    navigate(
                        `/teacher-classroom/liveclass/meeting?meetId=${meetId}`,
                        {
                            state: {
                            ...state,
                            sessionId: singleSessionDetail?.sessionId,
                            },
                        }
                    ); 
              }
            }
          })
          .catch(() => {
            localStorage.setItem("isJoined", "left");
            dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
            setLoading(false);
            stream?.getAudioTracks()[0].stop();
            stream?.getVideoTracks()[0].stop();
          });
      }        
    }

    const workshopStartFunctionality = async (stream:any) => {
            
      if(currentUserId) {
            await createMeeting(currentUserId).then(async (response) => {
                const meetId = response?.Meeting?.MeetingId;
                trackMettingEvent(`${singleWorkshopDetail?.wsStatus === "STARTED" ? "j" : "s"}`, {
                  meetingId: meetId!,
                  participantId: currentUserId,
                });
                // const data = await response.json();
                if (meetId) {
                    if(currentUserId) {
                        updateUserProperties({
                            meetingId: meetId, // overwrite old value
                        });
                        captureEvent(currentUserId, {
                            role: role,
                            loginType: loginpage, // your redux login type
                            meetingId: meetId,
                        });
                    }

                    const participants = await getChimeParticipants(meetId);
                    let hostAttendee:any = null;
                    // Find the host attendee
                    if(participants?.Attendees){
                        hostAttendee =  participants.Attendees.find(
                            (attendee) => attendee.ExternalUserId === currentUserId
                        );
                    }

                    console.log("Host AttendeeId while creating:", hostAttendee?.AttendeeId);
                    localStorage.setItem("hostId", currentUserId ?? "");
                    localStorage.setItem("hostAttendeeId", hostAttendee?.AttendeeId ?? "");
                    setHostAttendeeId(hostAttendee?.AttendeeId || '');

                    const chatStatus = (singleWorkshopDetail?.wsStatus === "STARTED") ? (localStorage.getItem("showChatPreference") ? JSON.parse(localStorage.getItem("showChatPreference") || "false") : false) : singleWorkshopDetail?.showChat;
                    await updateSessionId({
                        variables: {
                            updateInput: {
                                wsCode: meetId,
                                wsStatus: "STARTED",
                                hostId: currentUserId,
                                showChat: chatStatus,
                                originalHostId : currentUserId
                            },
                            wsId: singleWorkshopDetail?.wsId
                        }
                    })
                    if (singleWorkshopDetail?.wsId) {
                        if (singleWorkshopDetail?.wsStatus === "STARTED") {
                            setShowChat(singleWorkshopDetail?.showChat);
                        }
                        dispatch(setCurrentWorkshopId({ currentWorkshopId: singleWorkshopDetail?.wsId }));
                        localStorage.setItem("SessionId",singleWorkshopDetail?.wsId);
                        dispatch(setCurrentSessionDetail({ startDate: singleWorkshopDetail?.wsStartTime, endDate: singleWorkshopDetail?.wsEndTime, mediaPipelineArn : singleWorkshopDetail?.mediaPipelineArn ?? null , mediaPipelineId : singleWorkshopDetail?.mediaPipelineId ?? null }));
                        dispatch(setCurrentSessionRecordingDetail({ recordingStartedTime: singleWorkshopDetail?.recordStartTime, recordingStarted: singleWorkshopDetail?.isRecordStart }));
                    }        
                    if(meetId && currentUserId) {
                    trackMettingEvent(`${singleWorkshopDetail?.wsStatus === "STARTED" ? "j" : "s"}`, {
                        meetingId: meetId!,
                        participantId: currentUserId,
                    });     
                    }
                    if(currentUserId) {
                        updateUserProperties({
                            meetingId: meetId, // overwrite old value
                        });
                        captureEvent(currentUserId, {
                            role: role,
                            loginType: loginpage, // your redux login type
                            meetingId: meetId,
                        });
                    }  
                    const existingState = state; // coming from useLocation() or props   
                    const newState = {
                        ...existingState,
                        sessionId: singleWorkshopDetail?.wsId
                    }
                    localStorage.setItem("meetingState", JSON.stringify(newState));
                    localStorage.setItem("isJoined", "joined");    
                    setLoading(false);
                    navigate(`/admin-workshop/meeting?meetId=${meetId}`, { state: { ...state, sessionId: singleWorkshopDetail?.wsId } });
                }
            }).catch((error) => {
                localStorage.setItem("isJoined", "left");
                dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
                setLoading(false);
                stream.getAudioTracks()[0].stop();
                stream.getVideoTracks()[0].stop();
            });
      }
    }

    const workshopJoinFunctionality = async (stream:any) => {
            dispatch(setCurrentUserId({ currentUserId: currentUserId || '' }));
            dispatch(setMeetComponentName({ meetComponent: 'workshop' }));
            if (singleWorkshopDetail?.wsCode && singleWorkshopDetail?.hostId) {
                let primaryMeetingId = singleWorkshopDetail?.wsCode;
                const replicaMeetingIds: string[] = singleWorkshopDetail?.replicaMeetingIds || [];

                // Combine the primary meeting and any replica meetings into one list
                const allMeetingIds = [primaryMeetingId, ...replicaMeetingIds];
                console.log("All Meeting Ids:", allMeetingIds);

                // Fetch participant counts for all meeting IDs in parallel
                const meetingCountsPromises = allMeetingIds.map(async (id) => {
                    const response = await getChimeParticipants(id);
                    const count = response?.Attendees ? response?.Attendees?.length : 0;
                    return { id, count };
                });
                const meetingCounts = await Promise.all(meetingCountsPromises);
                console.log("Meeting Counts:", meetingCounts);

                // Decide which meeting instance to join: choose the first meeting that isn't full.
                let chosenMeetingId: string | null = null;
                for (const { id, count } of meetingCounts) {
                    if (count < REPLICA_THRESHOLD) {
                        chosenMeetingId = id;
                        break;
                    }
                }

                // If all existing meeting instances are full, create a new replica meeting.
                if (!chosenMeetingId) {
                    const replicaMeetingResponse = await createChimeMeeting(singleWorkshopDetail?.wsCode);
                    const newReplicaMeetingId = replicaMeetingResponse?.Meeting?.MeetingId;
                    if (newReplicaMeetingId) {
                        // Update the replica meetings array by appending the new meeting ID.
                        const updatedReplicaMeetingIds = [...replicaMeetingIds, newReplicaMeetingId];
                        await updateSessionId({
                            variables: {
                                updateInput: { replicaMeetingIds: updatedReplicaMeetingIds },
                                wsId: singleWorkshopDetail?.wsId,
                            },
                        });
                        chosenMeetingId = newReplicaMeetingId;
                    }
                }

                // Fallback: if still no meeting is chosen, default to primary meeting
                const finalMeetingId = chosenMeetingId || primaryMeetingId;
                const originalHostId =  singleWorkshopDetail.originalHostId

                let hostAttendee:any = null;
                let hostExternalUserId:any = '';

                // Assume you already have these
                await getChimeParticipants(finalMeetingId)
                .then((participants) => {
                    console.log("[Log] Participants List:", participants);
                    console.log("userId", currentUserId, "singleWorkshopDetail.hostId", singleWorkshopDetail?.hostId, "originalHostId", originalHostId)
                    if(currentUserId === originalHostId) {
                    hostExternalUserId = currentUserId;
                    } else {
                    hostExternalUserId = singleWorkshopDetail.hostId;
                    }
                    // Find the host attendee
                    if(participants?.Attendees){
                        console.log("by using this hostExternalUserId", hostExternalUserId);
                        hostAttendee = participants.Attendees.find((attendee:any) => {
                            console.log("Checking attendee:", attendee.ExternalUserId);
                            return attendee.ExternalUserId === hostExternalUserId;
                        });
                    }
                })
                .catch((error) => {
                    console.error("Failed to fetch participants:", error);
                });

                
                if (hostAttendee) {
                console.log("Host AttendeeId:", hostAttendee.AttendeeId);
                } else {
                console.log("Host not found in the participants list");
                }

                if(currentUserId) {
                    updateUserProperties({
                         meetingId: singleWorkshopDetail?.wsCode, // overwrite old value
                    });
                    captureEvent(currentUserId, {
                        role: role,
                        loginType: loginpage, // your redux login type
                        meetingId: singleWorkshopDetail?.wsCode,
                    });
                }
                
                console.log(currentUserId, originalHostId, "originalHost")
                await joinMeeting(finalMeetingId, 
                    originalHostId === currentUserId ? currentUserId :
                     singleWorkshopDetail?.hostId === currentUserId
                        ? singleWorkshopDetail?.hostId
                        : `${currentUserId}|${Date.now()}`, 
                     singleWorkshopDetail?.hostId, originalHostId, hostAttendee?.AttendeeId || '')
                    .then(async (response) => {
                        console.log('[Log] joinMeeting response', response);
                        const meetId = response?.meetingResponse?.Meeting?.MeetingId;
                        if (meetId) {
                            if (currentUserId === originalHostId) {
                            await getChimeParticipants(meetId)
                                .then((participantsResponse) => {
                                    console.log("currentUserId", currentUserId, "singleWorkshopDetail.hostId", singleWorkshopDetail?.hostId, "originalHostId", originalHostId)
                                    hostExternalUserId = currentUserId;
                                    // Find the host attendee
                                    if(participantsResponse?.Attendees){        
                                        hostAttendee = participantsResponse.Attendees.find((attendee:any) => {
                                            console.log("Checking attendee:", attendee.ExternalUserId);
                                            return attendee.ExternalUserId === hostExternalUserId;
                                        });
                                        console.log("Host AttendeeId after joining:", hostAttendee?.AttendeeId || '');
                                        setHostAttendeeId(hostAttendee?.AttendeeId || '');
                                        console.log(singleWorkshopDetail?.mediaPipelineArn, singleWorkshopDetail?.mediaPipelineId, "mediapipeline", originalHostId)
                                        localStorage.setItem("hostId", currentUserId ?? "");
                                        localStorage.setItem("hostAttendeeId", hostAttendee?.AttendeeId ?? ""); 
                                    }
                                })
                                .catch((error) => {
                                    console.error("Failed to fetch participants:", error);
                                });

                              console.log(currentUserId, originalHostId, "originalHost")
                              setHostId(currentUserId);
                              console.log(singleWorkshopDetail?.mediaPipelineArn, singleWorkshopDetail?.mediaPipelineId, "mediapipeline", originalHostId)
                              
                              setMediaPipelineArn(singleWorkshopDetail?.mediaPipelineArn)
                              setMediaPipelineId(singleWorkshopDetail?.mediaPipelineId)
                            meetingManager.audioVideo?.addObserver({
                            audioVideoDidStart: () => {
                                console.log('[Log] audioVideoDidStart - Sending realtime message');
                                try {
                                const message = {
                                    action: "host-changed",
                                    hostId: currentUserId,
                                    hostAttendeeId: hostAttendee?.AttendeeId || '',
                                    ...(singleWorkshopDetail?.mediaPipelineId && {
                                    mediaPipelineId: singleWorkshopDetail.mediaPipelineId,
                                    }),
                                    ...(singleWorkshopDetail?.mediaPipelineArn && {
                                    mediaPipelineArn: singleWorkshopDetail.mediaPipelineArn,
                                    }),
                                };

                                meetingManager.meetingSession?.audioVideo?.realtimeSendDataMessage(
                                    "live-update",
                                    JSON.stringify(message)
                                );
                                } catch (error) {
                                console.error("Failed to send realtime message:", error);
                                }
                            },
                            });

                              await updateSessionId({
                                variables: {
                                  updateInput: {
                                    hostId: currentUserId,
                                  },
                                  wsId: singleWorkshopDetail?.wsId,
                                },
                              });
                            }
                            if (singleWorkshopDetail?.wsId) {
                                 localStorage.setItem("SessionId",singleWorkshopDetail?.wsId);
                                dispatch(setCurrentWorkshopId({ currentWorkshopId: singleWorkshopDetail?.wsId }));
                                dispatch(setCurrentSessionDetail({ startDate: singleWorkshopDetail?.wsStartTime, endDate: singleWorkshopDetail?.wsEndTime , mediaPipelineArn : singleWorkshopDetail?.mediaPipelineArn ?? null , mediaPipelineId : singleWorkshopDetail?.mediaPipelineId ?? null }));
                                dispatch(setCurrentSessionRecordingDetail({ recordingStartedTime: singleWorkshopDetail?.recordStartTime, recordingStarted: singleWorkshopDetail?.isRecordStart }));
                                setRecordingStartTime(singleWorkshopDetail?.recordStartTime);
                                setIsRecording(singleWorkshopDetail?.isRecordStart);
                                setShowChat(singleWorkshopDetail?.showChat);
                            }
                            if(meetId && currentUserId) {
                            trackMettingEvent("j", {
                                meetingId: meetId!,
                                participantId: currentUserId,
                            });
                            }
                            if(currentUserId) {
                                updateUserProperties({
                                    meetingId: meetId, // overwrite old value
                                });
                                captureEvent(currentUserId, {
                                    role: role,
                                    loginType: loginpage, // your redux login type
                                    meetingId: meetId,
                                });
                            }
                            const existingState = state; // coming from useLocation() or props   
                            const newState = {
                                ...existingState,
                                sessionId: singleWorkshopDetail?.wsId
                            }
                            localStorage.setItem("meetingState", JSON.stringify(newState));
                            localStorage.setItem("isJoined", "joined");    
                            setLoading(false);
                            if (role === SCHOOL_ADMIN) {
                                navigate(`/admin-workshop/meeting?meetId=${meetId}`, { state: { ...state, sessionId: singleWorkshopDetail?.wsId } });
                            } else if (role === TEACHER_ROLE) {
                                navigate(`/teacher-workshop/meeting?meetId=${meetId}`, { state: { ...state, sessionId: singleWorkshopDetail?.wsId } });
                            }
                        }
                    }).catch(() => {
                        localStorage.setItem("isJoined", "left");
                        dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
                        setLoading(false);
                        stream.getAudioTracks()[0].stop();
                        stream.getVideoTracks()[0].stop();
                    })
            }
    }

    const ptaStartFunctionality = async (stream:any) => {
      if(currentUserId) {
        await createMeeting(currentUserId).then(async (response) => {
          console.log('[Log] createMeeting response', response);
          const meetId = response?.Meeting?.MeetingId;
          if (meetId) {
            const participants = await getChimeParticipants(meetId);
            let hostAttendee: any = null;
            // Find the host attendee
            if (participants?.Attendees) {
                hostAttendee = participants.Attendees.find(
                    (attendee) => attendee.ExternalUserId === currentUserId
                );
            }

            console.log(
                "Host AttendeeId while creating:",
                hostAttendee?.AttendeeId
            );
            localStorage.setItem("hostId", currentUserId ?? "");
            localStorage.setItem(
                "hostAttendeeId",
                hostAttendee?.AttendeeId ?? ""
            );
            setHostAttendeeId(hostAttendee?.AttendeeId || "");
            const chatStatus = (singlePtaDetail?.mStatus === "NOT_STARTED") ? (localStorage.getItem("showChatPreference") ? JSON.parse(localStorage.getItem("showChatPreference") || "false") : false) : singlePtaDetail?.showChat;
            updateMeetStatus({
              variables: {
                updateInput: {
                  mCode: meetId,
                  mStatus: "STARTED",
                  hostId: currentUserId,
                  showChat: chatStatus,
                  originalHostId : currentUserId
                },
                mId: singlePtaDetail?.mId,
              }
            });
            if (singlePtaDetail?.mId) {
              if (singlePtaDetail?.mStatus === "STARTED") {
                setShowChat(singlePtaDetail?.showChat);
              }
              dispatch(setCurrentPtaMeetId({ currentPtaMeetId: singlePtaDetail?.mId }));
              localStorage.setItem("SessionId",singlePtaDetail?.mId);
              dispatch(setCurrentPtaMeetMCode({ currentPtaMeetMCode: meetId }));
              dispatch(setCurrentSessionDetail({ startDate: singlePtaDetail?.mStartTime, endDate: singlePtaDetail?.mEndTime, mediaPipelineArn : singlePtaDetail?.mediaPipelineArn ?? null , mediaPipelineId : singlePtaDetail?.mediaPipelineId ?? null }));
              dispatch(setCurrentSessionRecordingDetail({ recordingStartedTime: singlePtaDetail?.recordStartTime, recordingStarted: singlePtaDetail?.isRecordStart }));
              dispatch(setCurrentSessionTopic({ currentSessionTopic: singlePtaDetail?.mTopic }));
            }
            if(currentUserId) {
                updateUserProperties({
                    meetingId: meetId,
                });
                captureEvent(currentUserId, {
                    role: role,
                    loginType: loginpage, // your redux login type
                    meetingId: meetId,
                });
          }
            const existingState = state; // coming from useLocation() or props   
            const newState = {
              ...existingState,
              sessionId: singlePtaDetail?.mId
            }
            localStorage.setItem("meetingState", JSON.stringify(newState));
            localStorage.setItem("isJoined", "joined");    
            setLoading(false);
            navigate(`/admin/pta/meeting?meetId=${meetId}`, {
              state: { ...state, sessionId: singlePtaDetail?.mId }
            });
          }
        }).catch((error) => {
          console.log("Creating Meeting Error :", error);
          localStorage.setItem("isJoined", "left");
          setLoading(false);
          dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
          stream.getAudioTracks()[0].stop();
          stream.getVideoTracks()[0].stop();
        });
      }
    }

    const ptaJoinFunctionality = async (stream:any) => {
      dispatch(setCurrentUserId({ currentUserId: currentUserId || '' }));
      dispatch(setMeetComponentName({ meetComponent: 'pta' }));
      if (singlePtaDetail?.mCode && singlePtaDetail?.hostId) {
        let primaryMeetingId = singlePtaDetail?.mCode;
        const replicaMeetingIds: string[] =
            singlePtaDetail?.replicaMeetingIds || [];

        // Combine the primary meeting and any replica meetings into one list
        const allMeetingIds = [primaryMeetingId, ...replicaMeetingIds];
        console.log("All Meeting Ids:", allMeetingIds);

        // Fetch participant counts for all meeting IDs in parallel
        const meetingCountsPromises = allMeetingIds.map(async (id) => {
            const response = await getChimeParticipants(id);
            const count = response?.Attendees ? response?.Attendees?.length : 0;
            return { id, count };
        });
        const meetingCounts = await Promise.all(meetingCountsPromises);
        console.log("Meeting Counts:", meetingCounts);

        // Decide which meeting instance to join: choose the first meeting that isn't full.
        let chosenMeetingId: string | null = null;
        for (const { id, count } of meetingCounts) {
            if (count < REPLICA_THRESHOLD) {
                chosenMeetingId = id;
                break;
            }
        }

        // If all existing meeting instances are full, create a new replica meeting.
        if (!chosenMeetingId) {
            const replicaMeetingResponse = await createChimeMeeting(
                singlePtaDetail?.mCode
            );
            const newReplicaMeetingId =
                replicaMeetingResponse?.Meeting?.MeetingId;
            if (newReplicaMeetingId) {
                // Update the replica meetings array by appending the new meeting ID.
                const updatedReplicaMeetingIds = [
                    ...replicaMeetingIds,
                    newReplicaMeetingId,
                ];
                updateMeetStatus({
                  variables: {
                    updateInput: {
                      replicaMeetingIds: updatedReplicaMeetingIds,
                    },
                    mId: singlePtaDetail?.mId,
                  }
                });
                chosenMeetingId = newReplicaMeetingId;
            }
        }

        // Fallback: if still no meeting is chosen, default to primary meeting
        const finalMeetingId = chosenMeetingId || primaryMeetingId;
        const originalHostId = singlePtaDetail.originalHostId;

        let hostAttendee: any = null;
        let hostExternalUserId: any = "";

        // Assume you already have these
        await getChimeParticipants(finalMeetingId)
            .then((participants) => {
                console.log("[Log] Participants List:", participants);
                console.log(
                    "userId",
                    currentUserId,
                    "singlePtaDetail.hostId",
                    singlePtaDetail.hostId,
                    "originalHostId",
                    originalHostId
                );
                if (currentUserId === originalHostId) {
                    hostExternalUserId = currentUserId;
                } else {
                    hostExternalUserId = singlePtaDetail.hostId;
                }
                // Find the host attendee
                if (participants?.Attendees) {
                    console.log(
                        "by using this hostExternalUserId",
                        hostExternalUserId
                    );
                    hostAttendee = participants.Attendees.find(
                        (attendee: any) => {
                            console.log(
                                "Checking attendee:",
                                attendee.ExternalUserId
                            );
                            return (
                                attendee.ExternalUserId === hostExternalUserId
                            );
                        }
                    );
                }
            })
            .catch((error) => {
                console.error("Failed to fetch participants:", error);
            });

        if (hostAttendee) {
            console.log("Host AttendeeId:", hostAttendee.AttendeeId);
        } else {
            console.log("Host not found in the participants list");
        }     
        await joinMeeting(
          singlePtaDetail.mCode,
          (originalHostId === currentUserId) ? currentUserId :
              (singlePtaDetail.hostId === currentUserId)
              ? singlePtaDetail.hostId
              : `${currentUserId}|${Date.now()}`, 
          singlePtaDetail.hostId, 
          originalHostId, hostAttendee?.AttendeeId || '')
          .then(async (response) => {
            console.log('[Log] joinMeeting response', response);
            const meetId = response?.meetingResponse?.Meeting?.MeetingId;
            // const data = await response.json();
            if (meetId) {
              // const {meetId, user, host, createdAt} = data.meetInfo;
              if (currentUserId === originalHostId) {
                  await getChimeParticipants(meetId)
                      .then((participantsResponse) => {
                          console.log(
                              "userId",
                              currentUserId,
                              "singlePtaDetail.hostId",
                              singlePtaDetail.hostId,
                              "originalHostId",
                              originalHostId
                          );
                          hostExternalUserId = currentUserId;
                          // Find the host attendee
                          if (participantsResponse?.Attendees) {
                              hostAttendee =
                                  participantsResponse.Attendees.find(
                                      (attendee: any) => {
                                          console.log(
                                              "Checking attendee:",
                                              attendee.ExternalUserId
                                          );
                                          return (
                                              attendee.ExternalUserId ===
                                              hostExternalUserId
                                          );
                                      }
                                  );
                              console.log(
                                  "Host AttendeeId after joining:",
                                  hostAttendee?.AttendeeId || ""
                              );
                              setHostAttendeeId(hostAttendee?.AttendeeId || "");
                              console.log(
                                  singlePtaDetail.mediaPipelineArn,
                                  singlePtaDetail.mediaPipelineId,
                                  "mediapipeline",
                                  originalHostId
                              );
                              localStorage.setItem("hostId", currentUserId ?? "");
                              localStorage.setItem(
                                  "hostAttendeeId",
                                  hostAttendee?.AttendeeId ?? ""
                              );
                          }
                      })
                      .catch((error) => {
                          console.error("Failed to fetch participants:", error);
                      });

                  console.log(currentUserId, originalHostId, "originalHost");
                  setHostId(currentUserId);
                  console.log(
                      singlePtaDetail.mediaPipelineArn,
                      singlePtaDetail.mediaPipelineId,
                      "mediapipeline",
                      originalHostId
                  );

                  setMediaPipelineArn(singlePtaDetail.mediaPipelineArn);
                  setMediaPipelineId(singlePtaDetail.mediaPipelineId);
                  meetingManager.audioVideo?.addObserver({
                      audioVideoDidStart: () => {
                          console.log(
                              "[Log] audioVideoDidStart - Sending realtime message"
                          );
                          try {
                              const message = {
                                  action: "host-changed",
                                  hostId: currentUserId,
                                  hostAttendeeId:
                                      hostAttendee?.AttendeeId || "",
                                  ...(singlePtaDetail.mediaPipelineId && {
                                      mediaPipelineId:
                                          singlePtaDetail.mediaPipelineId,
                                  }),
                                  ...(singlePtaDetail.mediaPipelineArn && {
                                      mediaPipelineArn:
                                          singlePtaDetail.mediaPipelineArn,
                                  }),
                              };

                              meetingManager.meetingSession?.audioVideo?.realtimeSendDataMessage(
                                  "live-update",
                                  JSON.stringify(message)
                              );
                          } catch (error) {
                              console.error(
                                  "Failed to send realtime message:",
                                  error
                              );
                          }
                      },
                  });

                  await updateMeetStatus({
                    variables: {
                      updateInput: {
                        mCode: singlePtaDetail?.mCode,
                        hostId: currentUserId,
                      },
                      mId: singlePtaDetail?.mId,
                    }
                  })
              }
              if (singlePtaDetail?.mId) {
                dispatch(setCurrentPtaMeetId({ currentPtaMeetId: singlePtaDetail?.mId }));
                localStorage.setItem("SessionId",singlePtaDetail?.mId);
                dispatch(setCurrentPtaMeetMCode({ currentPtaMeetMCode: singlePtaDetail?.mCode }));
                dispatch(setCurrentSessionDetail({ startDate: singlePtaDetail?.mStartTime, endDate: singlePtaDetail?.mEndTime, mediaPipelineArn : singlePtaDetail?.mediaPipelineArn ?? null , mediaPipelineId : singlePtaDetail?.mediaPipelineId ?? null }));
                dispatch(setCurrentSessionRecordingDetail({ recordingStartedTime: singlePtaDetail?.recordStartTime, recordingStarted: singlePtaDetail?.isRecordStart }));
                setRecordingStartTime(singlePtaDetail?.recordStartTime);
                setIsRecording(singlePtaDetail?.isRecordStart);
                dispatch(setCurrentSessionTopic({ currentSessionTopic: singlePtaDetail?.mTopic }));
                setShowChat(singlePtaDetail?.showChat);
              }
              if(currentUserId) {
                    updateUserProperties({
                         meetingId: meetId, // overwrite old value
                    });
                    captureEvent(currentUserId, {
                        role: role,
                        loginType: loginpage, // your redux login type
                        meetingId: meetId,
                    });
              }
              const existingState = state; // coming from useLocation() or props   
              const newState = {
                  ...existingState,
                  sessionId: singleWorkshopDetail?.wsId
              }
              localStorage.setItem("meetingState", JSON.stringify(newState));
              localStorage.setItem("isJoined", "joined");    
              setLoading(false);              
              if (role === PTA_ROLE) {
                navigate(`/pta/meeting?meetId=${meetId}`, {
                  state: { ...state, sessionId: singlePtaDetail?.mId }
                });
              }
              else if (role === SCHOOL_ADMIN) {
                navigate(`/admin/pta/meeting?meetId=${meetId}`, {
                  state: { ...state, sessionId: singlePtaDetail?.mId }
                });
              }
              else if (role === TEACHER_ROLE) {
                navigate(`/teacher/pta/meeting?meetId=${meetId}`, {
                  state: { ...state, sessionId: singlePtaDetail?.mId }
                });
              }
            }
          }).catch(() => {
            localStorage.setItem("isJoined", "left");
            dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
            setLoading(false);
            stream.getAudioTracks()[0].stop();
            stream.getVideoTracks()[0].stop();
          })
      }        
    }

    useEffect(() => {
        const meetId = searchParams.get("meetId");
        console.log("PreChimeMeeting meetId:", meetId, selectedClassRoomId, selectedSubjectId, meetComponent);
        if(meetComponent === 'liveclass' && selectedClassRoomId && selectedSubjectId && meetId) {
            getSingleSession({
            variables: {
                input: {
                cId: selectedClassRoomId,
                sjId: selectedSubjectId,
                sId: meetId
                }
            }
            });
        } else if (meetComponent === 'workshop' && meetId) {
            getSingleWorkshopSession({
                variables: {
                    input: {
                        wsId: meetId
                    }
                }
            })
        } else if (meetComponent === 'pta' && meetId) {
            getSinglePtaMeeting({
              variables:{
                mId: meetId
              }
            });
        }
    }, []);

    useEffect(() => {
        console.log("singleSessionDetail changed:", singleSessionDetail, meetComponent);
        const functionality = localStorage.getItem('functionality');
        if(singleSessionDetail?.sessionId && meetComponent === 'liveclass') {
            if(functionality && functionality === 'start') {
                const stream:any = getPreviewStream();
                if (stream) {   
                    liveclassStartFunctionality(stream);
                }
            } else if(functionality && functionality === 'join') {
                const stream:any = getPreviewStream();
                if (stream) {
                    liveclassJoinFunctionality(stream);
                }
            }
        } else if (singleWorkshopDetail?.wsId && meetComponent === 'workshop') {
           if(functionality && functionality === 'start') {
                const stream:any = getPreviewStream();
                if (stream) {   
                    workshopStartFunctionality(stream);
                }
            } else if(functionality && functionality === 'join') {
                const stream:any = getPreviewStream();
                if (stream) {
                    workshopJoinFunctionality(stream);
                }
            }
        } else if (singlePtaDetail?.mId && meetComponent === 'pta') {
           if(functionality && functionality === 'start') {
                const stream:any = getPreviewStream();
                if (stream) {   
                    ptaStartFunctionality(stream);
                }
            } else if(functionality && functionality === 'join') {
                const stream:any = getPreviewStream();
                if (stream) {
                    ptaJoinFunctionality(stream);
                }
            }
        }
    }, [singleSessionDetail, singleWorkshopDetail, singlePtaDetail, meetComponent]);

  return (
    <>
        {loading && <Loader/>}
        <WarningPopup
            message={ warningMessage }
            openWarningPopup={ openWarningPopup }
            closeWarnPopup={ closeWarnPopup }
        />    
    </>
    
  )
}

export default PreChimeMeeting